'use strict';


let IS_DEBUG = false; //如果是测试环境就是true，如果是生产环境就是false
// const commonUrl = IS_DEBUG ? 'api/' : '//da.cnbooking.net/api/' //测试

const commonUrl = IS_DEBUG ? 'api/' : '//api.dingfangyi.com/api/' //生产

export default {
    //cnbooking api config
    login: commonUrl + 'Token',
    payCode: 'lmy-api-test.cnbooking.net',
    domain: 'lmy.cnbooking.net', //支付地址
    // checkAccount:commonUrl+'Account',//获取用户是否为代理信息
    getShareParam: commonUrl + 'Data/ShareParam',

    banner: commonUrl + 'Banner',
    bannerPresale: commonUrl + 'Banner/Small', //预售轮播图列表
    getPromotionAD: commonUrl + 'Banner/PromotionAD',
    weiFang: commonUrl + 'WeiFang',
    hotel: commonUrl + 'Hotel/Detail', //单个酒店信息/房型/价格查询
    getRoomImgs: commonUrl + 'Hotel/RoomImages', //单个酒店图片集
    getPrices: commonUrl + 'Hotel/Prices', //单个酒店的价格查询
    getDailyPrices: commonUrl + '/Hotel/DailyPrices', //单个酒店的价格查询
    price: commonUrl + 'Hotel/Search', //价格搜索
    upgrade: commonUrl + 'Hotel/Upgrade', //修改房间数量
    getLowestPrices: commonUrl + 'Prices/LowestPrices', //异步批量价格搜索
    getRestoreToken: commonUrl + 'Hotel/RestoreToken', //查询解析
    getChimelong: commonUrl + 'Hotel/Chimelong/Seasons', //长隆数据
    getChimelongMeals: commonUrl + 'Hotel/Chimelong/Meals', //长隆早餐
    getChimelongSubpro: commonUrl + 'Hotel/Chimelong/ProductInfo', //长隆酒店子产品信息查询

    addTF: commonUrl + 'TF/Add', //添加团房信息
    getTF: commonUrl + 'TF/Search', //查询团房列表
    getTFCity: commonUrl + 'TF/Hotel/GetCity', //查询团房城市
    getTFHotel: commonUrl + 'TF/Hotel/Search', //查询团房酒店

    getLandmark: commonUrl + 'Suggestion/Landmark', //获取行政区和商圈
    getLandmarkGroups: commonUrl + 'Suggestion/LandmarkGroups', //获取地标分组
    getHotelAndLandmarks: commonUrl + 'Suggestion/HotelAndLandmarks', //酒店和地标混合 自动完成
    getCountry: commonUrl + 'Suggestion/Country', //国家模糊查询
    cnHotCity: commonUrl + 'Data/CNHotCity', //国内热门城市
    foreignHotCity: commonUrl + 'Data/ForeignHotCity', //海外热门城市
    getHotCityHotels: commonUrl + 'Data/HotCityHotels', //热门城市

    cruiseDepartures: commonUrl + 'Data/CruiseDepartures', //获取邮轮出发地
    cruiseCompanys: commonUrl + 'Data/CruiseCompanys', //获取邮轮出发地
    getTravelDestinations: commonUrl + 'Data/ZYXDestinations', //获取自游行目的地
    getLocateCity: commonUrl + 'Data/LocateCity', //匹配城市,

    create_page_auth: commonUrl + 'Data/create_page_auth', //创建权限

    autoComplete: commonUrl + 'Suggestion/Hotel', //获取酒店自动完成信息
    autoCityComplete: commonUrl + 'Suggestion/Region', //获取城市/区域自动完成信息
    getMyOrderList: commonUrl + 'Orders/My/Search', //订单查询
    getOrderList: commonUrl + 'Orders/Search', //订单查询
    getOrderReport: commonUrl + 'Orders/Report', //用于报表查询
    getMyOrderDetails: commonUrl + 'Orders/My', //订单查询详情
    getOrderDetails: commonUrl + 'Orders', //订单查询详情
    getOrderDetails1: commonUrl + 'Orders/OrderDetail', //无权限接口外部调用
    qr: commonUrl + 'Orders/QR', //订单二维码
    getCommissionList: commonUrl + 'Orders/Commission', //佣金订单列表

    getAccount: commonUrl + 'Account', //获取基础信息
    getReceipts: commonUrl + 'Bill/Receipts', //获取金额使用详情
    getReceiptsNew: commonUrl + 'Bill/Receipts/New', //获取金额使用详情
    getRecharges: commonUrl + 'Bill/Recharges', //获取充值详情
    getAubAccounts: commonUrl + 'Account/SubAccounts', //获取子账号列表
    getSwitchStatus: commonUrl + 'Account/SwitchStatus', //切换子账号状态
    getIsSubscribed: commonUrl + 'Account/IsSubscribed', //获取账号是否已经关注了公众号
    getUserQR: commonUrl + 'Account/QR', //获取账号推广二维码
    getMyUserQR: commonUrl + 'Account/QR2', //获取账号推广二维码
    changePwd: commonUrl + 'Account/ChangePwd', //修改密码
    addAccount: commonUrl + 'Account/Add', //添加新用户
    putAccount: commonUrl + 'Account/Edit', //修改信息

    getBills: commonUrl + 'Commission/Bills', //获取佣金列表
    getWithdraws: commonUrl + 'Commission/Withdraws', //获取提现列表
    withdraw: commonUrl + 'Commission/Withdraw', //提现

    getBill: commonUrl + 'bill', //获取账单

    getMyMembers: commonUrl + 'Account/MyMembers', //我的下级

    getUserInfo: commonUrl + 'Account', //获取账号信息，同时会刷新信用额度使用情况
    createBook: commonUrl + 'Orders/Create', //创建酒店订单
    checkAccount: commonUrl + 'CNPay/Check', //查询是否有额度，有的话直接下单，
    checkPackageAccount: commonUrl + 'CNPay/Package/Check', //查询是否有额度，有的话直接下单，
    clearAccount: commonUrl + 'CNPay/Package/XiaoZhang', //销账，
    aliPay: commonUrl + 'AliPay', //阿里支付
    wxPay: commonUrl + 'WXPay/GetPayQR', //微信支付
    YopPay: commonUrl + 'YopPay/GetPayQR', //易宝支付
    getPromotions: commonUrl + 'Promotions', //查看是否有首单减免
    checkBookable: commonUrl + 'Orders/Check', //检查酒店是否可以预订
    cancelOrder: commonUrl + 'Orders/Cancel', //取消订单

    getReport: commonUrl + 'Report', //报表查询
    getAdvanceDays: commonUrl + 'Report/AdvanceDays', //提前预订天数分布报表
    getNightCounts: commonUrl + 'Report/NightCounts', //连住晚数分布报表

    getPresalePayParam: commonUrl + 'WXPay/Presale/GetPayParam', //获取预售订单的支付地址

    getPayParam: commonUrl + 'WXPay/GetPayParam', //获取订单的支付地址
    getWxPayStatus: commonUrl + 'WXPay/GetPayStatus', //获取订单的微信支付状态
    getAliPayStatus: commonUrl + 'AliPay/GetPayStatus', //获取订单的支付宝支付状态

    getFavorites: commonUrl + 'Favorite', //获取用户的收藏数据
    addFavorite: commonUrl + 'Favorite', //添加收藏
    removeFavorite: commonUrl + 'Favorite/Delete', //删除收藏
    isFavoriteExist: commonUrl + 'Favorite/Exists', //是否已收藏

    // 抢购
    getPreSaleList: commonUrl + 'Presale/Search', //抢购查询
    getPreSaleStock: commonUrl + 'PreSale/Stock', //抢购已卖数量
    getPreSaleDetails: commonUrl + 'Presale/Detail', //抢购详情
    getPreSaleQr: commonUrl + 'PreSale/QR', //抢购详情二维码
    getPreSaleMedia: commonUrl + 'PreSale/Media', //抢购详情图片
    preSaleBook: commonUrl + 'Orders/Presale/Check', //抢购详情下单检查
    preSaleCreate: commonUrl + 'Orders/Presale/Create', //抢购详情下单
    getSaleOrderList: commonUrl + 'Orders/Presale/Search', //抢购订单列表
    getSaleOrderDetails: commonUrl + 'Orders/Presale', //抢购订单详情

    // 获取自由行
    getPackageHotCity: commonUrl + 'Package/HotCity', //获取直连热门城市
    getPackageList: commonUrl + 'Package/Search', //获取直连产品列表
    getPackageDetail: commonUrl + 'Package/Detail', //获取直连产品详情
    getPackageSKUs: commonUrl + 'Package/SKUs', //获取直连产品SKUs
    getPackagePrices: commonUrl + 'Package/Prices', //获取直连产品SKUs
    getPackageCheck: commonUrl + 'Orders/Package/Check', //直连产品可定检查
    getPackageCreate: commonUrl + 'Orders/Package/Create', //直连产品可定检查
    getPackageOrderList: commonUrl + 'Orders/Package/Search', //直连订单列表
    getPackageOrderDetails: commonUrl + 'Orders/Package/Detail', //直连订单详情
    getReserveInfo: commonUrl + 'Orders/Package/ReserveInfo', //可预约信息
    getPackageReserve: commonUrl + 'Orders/Package/Reserve', //预约下单
    cancelPackageOrder: commonUrl + 'Orders/Package/Cancel', //取消直连订单
    packageAliPay: commonUrl + 'AliPay/Package/PayParams', //阿里支付
    packageWxPay: commonUrl + 'WXPay/Package/GetPayQR', //微信支付
    packageYopPay: commonUrl + 'YopPay/Package/GetPayQR', //易宝支付
    packageAliPayStatus: commonUrl + 'AliPay/Package/PayStatus', //阿里支付状态
    packageWxPayStatus: commonUrl + 'WXPay/Package/PayStatus', //微信支付状态


    //门票

    getTicketList: commonUrl + 'Ticket/Search', //门票列表
    getticketDetails: commonUrl + 'Ticket/Detail', //门票详情
    getticketDaily: commonUrl + 'Ticket/Prices', //门票价格日历
    getTicketPriceRange: commonUrl + 'Ticket/TicketPriceRange', //根据列表门票价格
    getScenicPriceRange: commonUrl + 'Ticket/ScenicPriceRange', //根据景点获取门票价格
    createTicket: commonUrl + 'Orders/Ticket/Create', //门票下单
    checkTicket: commonUrl + 'Orders/Ticket/Check', //门票可订检查
    getTicketOrderDetails: commonUrl + 'Orders', //门票订单详情


    //发票
    InvoiceSearch: commonUrl + 'Invoice/Search', //申请酒店发票
    InvoiceSave: commonUrl + 'Invoice/Save', //酒店发票
    InvoiceSearchInvoices: commonUrl + 'Invoice/SearchInvoices', //发票信息
    InvoiceOrderNo: commonUrl + 'Invoice/orderNo', //发票详情


    regist: commonUrl + 'Account/Regist', //注册
    district: commonUrl + 'Data/District', //获取子城市
    captcha: commonUrl + 'Data/Captcha', //获取验证码
    getSMS: commonUrl + 'Data/SMS', //手机登录验证码

    imgUrl: 'http://sz.cnbooking.net/',
    appId: 'wx5f1836dc0b012e9d', //公众号app id

    baiduMapLocation: 'https://api.map.baidu.com/location/ip?ip=&ak=c85jO1c0e0Ti1iBz3jnAGgacO4VMxsij&coor=bd09ll'


}


// WEBPACK FOOTER //
// ./src/common/ApiFactory.js